import React from 'react';

const KOutlineBg = ({ color = 'yellow' }) => {
  const src = color === 'yellow'
    ? '/assets/kalobrate-icon-outline-yellow.png'
    : '/assets/kalobrate-icon-outline-carbon.png';
  
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="absolute top-[-10%] right-[-5%] w-[55%] h-[120%] object-contain opacity-[0.06] pointer-events-none select-none"
    />
  );
};

export default KOutlineBg;
